// @flow strict
import { createClient } from 'contentful'
import React, { useEffect, useState } from 'react'
import { locale } from '../Global'

type ContentfulClient = {
  getEntries(): Promise<{}>,
}

export const ContentfulContext = React.createContext<ContentfulClient>({})

export const contentfulClient = createClient({
  space: process.env.GATSBY_CONTENTFUL_MARKETING_SPACE_ID || '',
  accessToken: process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN_CMS || '',
  host: process.env.GATSBY_CONTENTFUL_HOST || '',
})

export const useGetBlogRoll = (categoryName: string, limit: number = 3) => {
  const [error, setError] = useState(undefined)
  const [posts, setPosts] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    async function getEntries() {
      setError(null)
      setIsLoading(true)
      try {
        const { items } = await contentfulClient.getEntries({
          locale,
          limit: 1,
          content_type: 'blogCategory',
          select: 'sys.id',
          'fields.categoryName': categoryName,
        })
        const posts = await contentfulClient.getEntries({
          locale,
          limit,
          content_type: 'blogPost',
          links_to_entry: items[0].sys.id,
        })
        setPosts(posts.items)
        setIsLoading(false)
      } catch (e) {
        setError(e)
        setIsLoading(false)
      }
    }
    getEntries()
  }, [categoryName, limit])

  return [posts, error, isLoading]
}
